import React from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import { HashRouter } from 'react-router';
import App from 'containers/app';
import httpService from 'domain/interceptor';
import store from 'store';
import { intercomMutationObserver } from 'utils/intercom';

import 'scss/app.scss';

httpService.setupInterceptors(store);

const appRoot = document.getElementById('app-root');

intercomMutationObserver();

const root = createRoot(appRoot);
root.render(
    <Provider store={store}>
        <HashRouter>
            <App />
        </HashRouter>
    </Provider>,
);
